<template>
	<div>
		<v-container class="global-margin pb-0 mb-0">
      		<v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
		</v-container>
		<v-container class="content-wrap mt-0 pt-0">
			<v-row align="center" justify="center">
				<v-col cols="12" md="10">
					<div v-for="(item, i) in post.images" :key="i">
						<v-img max-height="450" v-if="i==0" :src="'https://web-admin.sum.ba/api/storage/' + item"></v-img>
					</div>
				</v-col>
			</v-row>
			<v-row align="center" justify="center">
				<v-col cols="12" md="8">
					<span class="subtitle-2 font-weight-regular text--secondary">Novosti</span>
					<h2 class="my-3">{{post.title}}</h2>
					<v-row class="mt-0 pt-0">
						<v-col cols="6" sm="4" class="mt-0 pt-0">
							<span class="grey--text"><v-icon color="grey" small left>far fa-calendar</v-icon> {{post.date_diff}}</span>
						</v-col>
						<v-col cols="6" sm="4" class="mt-0 pt-0">
							<span class="grey--text"><v-icon color="grey" small left>far fa-eye</v-icon> {{post.views}}</span>
						</v-col>
					</v-row>
					<p class="text--secondary font-weight-regular" v-html="post.content"></p>
				</v-col>
			</v-row>
		</v-container>
		<v-container class="content-wrap flex-center mt-12">
			<v-row class="w-100 flex-center">
				<v-col lg="4" md="6" cols="12" class="pa-3 flex-center" v-for="i in news" :key="i.id">
					<v-card class="article-card flex d-flex flex-column" :href="'/novosti/' + i.alias" shaped flat>
						<div class="article-img-wrap">
							<v-img class="white--text article-img img-fluid align-end" height="200px"
							       :src="'https://web-admin.sum.ba/api/storage/' + i.image"></v-img>
						</div>
						<v-card-subtitle class="pb-0">Novosti</v-card-subtitle>
						<v-card-title>
							<h3 class="title mb-0" style="overflow-y: auto; color: #084776">{{ i.title }}</h3>
						</v-card-title>
					</v-card>
				</v-col>
				<v-col lg="4" md="6" cols="12" class="pa-3 flex-center">
					<v-card class="flex d-flex article-card flex-column w-100" dark color="#094776" shaped flat>
						<logo class="ml-5 mt-5"></logo>
						<v-card-text class="headline font-weight-bold" style="overflow-y: auto;">Sve novosti i
							obavijesti vezane za digitalnu platformu u školstvu unutar županije.</v-card-text>
						<v-spacer></v-spacer>
						<v-card-actions class="card-link-action">
							<v-btn rounded color="#FFF" link to="/novosti" depressed
							       class="text-capitalize subtitle-2 moodle-btn blue-text pa-6 mb-4 ml-2">Pročitaj sve novosti</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Logo from "../components/Logo";
export default {
    name: "Novosti",
    data() {
        return {
            lista_slika: [],
            post: [],
            news: [],
            pagination_num: 0,
			page: 1,
			breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
		},
		{
          text: 'Novosti',
          disabled: false,
          href: '/novosti'
        },
        {
          text: '',
          disabled: true,
        },
      ],
        };
    },
    components: {
        Logo
    },
    mounted() {
        this.alias = this.$route.params.alias;
        this.getPost();
        this.getNews();
    },

    methods: {
        getPost() {
            let requestBody = {
                alias: this.alias
            };

            axios
                .post("https://web-admin.sum.ba/api/web/objava", requestBody)
                .then(response => {
					this.post = response.data;
                    for (let i = 0; i < this.post.images.length; i++) {
                        this.lista_slika.push(
                            "https://web-admin.sum.ba/api/storage/" + this.post.images[i]
                        );
					}
					this.breadcrumbs.forEach(element => {
						if(element.disabled){
							element.text = this.post.title
						}
					});
                })
                .catch(error => console.log(error.message));
        },
        getNews() {
            let requestBody = {
                page: this.page,
                postsPerPage: 2,
                categories: ["e-Škola"]
            };

            axios
                .post("https://web-admin.sum.ba/api/web/objave", requestBody)
                .then(response => {
                    this.news = response.data;
                    //   console.log(this.news);
                })
                .catch(error => console.log(error.message));
        }
    }
};
</script>

<style lang="scss" scoped>
	.novosti {
		margin-top: 150px;
	}

	@media (max-width: 768px) {
		.novosti {
			margin-top: 120px !important;
		}
	}

	.img-border {
		border-top-left-radius: 25px;
		border-bottom-left-radius: 4px;
	}

	.moodle-btn {
		letter-spacing: 0 !important;
		border-radius: 30px;
	}

	.article-card {
		min-height: 390px;
		width: 100%;
		.article-img-wrap {
			max-height: 200px;
			display: inline-block;
			overflow: hidden;
			.article-img {
				transition: transform .4s;
			}
		}
		&:hover {
			.article-img {
				transform: scale(1.1);
				transform-origin: 50% 50%;
			}
		}
	}
</style>
